/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PlaceMediaStateDto } from '../models/PlaceMediaStateDto';
import type { ReplacePlaceMediaDto } from '../models/ReplacePlaceMediaDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminPlaceMediaService {
  /**
   * @param id
   * @returns PlaceMediaStateDto
   * @throws ApiError
   */
  public static adminPlaceMediaControllerGet(id: string): CancelablePromise<PlaceMediaStateDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v2/admin/places/{id}/media-gallery',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @param ifMatch Quoted draft lockVersion.
   * @returns PlaceMediaStateDto
   * @throws ApiError
   */
  public static adminPlaceMediaControllerReplace(
    id: string,
    requestBody: ReplacePlaceMediaDto,
    ifMatch?: string,
  ): CancelablePromise<PlaceMediaStateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v2/admin/places/{id}/media-gallery',
      path: {
        id: id,
      },
      headers: {
        'If-Match': ifMatch,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
